
import { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import AuthManager from "../../../core/oidc";
import InfoCard from "../../../components/info-card";
import { CustomButton } from "../../../components/buttons";

const useStyles = makeStyles({
  text: {
    display: 'block',
    textAlign: 'center',
    marginBottom: 25
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'center'
  }
});

export default function LoggedOut() {

  const classes = useStyles();
  const [counter, setCounter] = useState(5);

  const redirectToLogin = async () => {
    await AuthManager.login();
  }

  useEffect(() => {
    const callback = async () => {
      await AuthManager.loggedOutCallback();
    };
    callback();
  }, []);

  useEffect(() => {
    if (counter === 0) {
      redirectToLogin();
    }

    if (counter > 0) {
      const interval = setTimeout(() => {
        setCounter(counter - 1);
        clearInterval(interval);
      }, 1000);
    }
  }, [counter]);

  return (

    <InfoCard>
      <h4 className={classes.text}>Başarıyla çıkış yaptınız</h4>
      <h5 className={classes.text}>{counter} saniye içinde giriş sayfasına yönlendiriliyorsunuz...</h5>
      <p className={classes.text}>Yönlendirmede sorun yaşarsanız aşağıdaki Giriş Yap butonunu kullanabilirsiniz.</p>
      <div className={classes.cardActions}>
        <CustomButton
          text="GİRİŞ YAP"
          className="btn-primary"
          onClick={redirectToLogin} />
      </div>
    </InfoCard>
  );
}
